import React, { useState } from 'react';
import { useTranslate } from '@bynder/localization';
import { Can } from '../../abilities/Can';
import { LanguageMenuButton } from '../UserMenu/LanguageMenu/LanguageMenuOLD';
import { useOutsideClick } from '../../helpers/useOutsideClick';

export function PublicMenu() {
	const { translate } = useTranslate();

	return (
		<ul className="admin-options">
			<PublicLanguageMenu />

			<li className="touch-block">
				<a title={translate('generalLogin')} className="profile" href="/login">
					{translate('generalLogin')}
				</a>
			</li>

			<Can I="show" a="user_request">
				<li>
					<a
						href="/user/login/?requestAccess"
						title={translate('request.requestAccess')}
						className="account-request"
					>
						{translate('request.requestAccess')}
					</a>
				</li>
			</Can>
		</ul>
	);
}

function PublicLanguageMenu() {
	const [isPinned, setIsPinned] = useState(false);
	const [isHover, setIsHover] = useState(false);

	const onOutsideClick = () => {
		setIsPinned(false);
	};

	const refButton = React.useRef<HTMLLIElement>(null);
	useOutsideClick(refButton, onOutsideClick);

	const onMouseEnter = () => {
		setIsHover(true);
	};

	const onMouseLeave = () => {
		setIsHover(false);
	};

	const onClick = () => {
		setIsPinned(true);
	};

	const isOpen = isHover || isPinned;

	return (
		<li
			ref={refButton}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onClick={onClick}
			className={`touch-block ${isPinned ? 'hover' : ''}`}
		>
			<LanguageMenuButton isOpen={isOpen} />
		</li>
	);
}
